import { render } from "./fugaokouqiang-news.vue?vue&type=template&id=a575bea2&scoped=true"
import script from "./fugaokouqiang-news.vue?vue&type=script&lang=js"
export * from "./fugaokouqiang-news.vue?vue&type=script&lang=js"

import "./fugaokouqiang-news.vue?vue&type=style&index=0&id=a575bea2&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\fuvview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a575bea2"]])

export default __exports__